import axios from 'axios';
import * as Pusher from 'pusher-js';

// const serverHost = process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : 'https://streams.soundtent.org/';
const serverHost = 'https://streams.soundtent.org/';

const pusher = new Pusher('4739dc7bab6d88089cb6', {
  cluster: 'eu',
  forceTLS: true,
});

const getEvent = async () => {
  try {
    const response = await axios.get(`${serverHost}/api/events?year=2026`);
    return response.data.data;
  } catch (error) {
    throw error;
  }
};


export { getEvent, pusher };

export default async () => {
  try {
    const response = await axios.get(`${serverHost}/api/streams?year=2026`);
    console.log(response.data.data);
    return response.data.data;
  } catch (error) {
    // handle error
    console.log(error);
    throw error;
  }
};



// WEBPACK FOOTER //
// ./src/api/api.js